<template>
  <table id="custom-tag-candidate_ai_summary" role="presentation" align="center" width="568" cellspacing="0" cellpadding="0" border="0" bgcolor="#ffffff" style="width: 568px; max-width: 568px; border-collapse: collapse; border-spacing: 0; background-color: #ffffff; color: #474646; font-family: Inter, Arial, sans-serif;">
    <tbody>
      <tr>
        <td style="padding: 24px 24px 0;">
          <table role="presentation" width="520" cellspacing="0" cellpadding="0" border="0" style="width: 520px; border-collapse: collapse; border-spacing: 0; table-layout: fixed;">
            <tbody>
              <tr>
                <td width="376" style="width: 376px; padding: 0 0 16px; border-bottom: 1px solid #dddddd; font-size: 16px; line-height: 22px; font-weight: 700; mso-line-height-rule: exactly;">{{ isEnglish ? 'Candidate Name' : '求职者姓名' }}</td>
                <td width="144" align="center" style="width: 144px; padding: 0 0 16px; border-bottom: 1px solid #dddddd; font-size: 16px; line-height: 22px; font-weight: 700; mso-line-height-rule: exactly;">{{ isEnglish ? 'Action' : '操作' }}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <td class="candidate-ai-summary mceNonEditable" width="568" style="width: 568px; min-height: 80px; padding: 0 24px; cursor: not-allowed;" v-html="candidateContent" />
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    candidateContent: {
      type: String,
      default: ''
    },
    languageCode: {
      type: String,
      required: true
    }
  },
  computed: {
    isEnglish () {
      return this.languageCode === 'en'
    }
  }
}
</script>
